function Icon() {
  return (
    <svg id='Layer_1_1_' version='1.1' viewBox='0 0 16 16' stroke='none'>
      <circle cx='8' cy='8' r='8' stroke='none' />
    </svg>
  );
}

export default Icon;
